// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__2eJjW","label":"Section_label__3_OLS","contentWrap":"Section_contentWrap__2pJA_","footer":"Section_footer__2o8LH","footerInner":"Section_footerInner__1Qmpm"};